
import Transformer from './../transformer'

export default class HighwayCompanyTransformer extends Transformer {
  static fetch(highwayCompany) {
    return {
      id: highwayCompany.id,
      name: highwayCompany.name,
      codeName: highwayCompany.codename,
      shortName: highwayCompany.short_name,
      // isActive: highwayCompany.is_active,
      // eslint-disable-next-line prefer-template
      logo: highwayCompany.logo ? ('http://localhost:8000' + highwayCompany.logo) : null,
    }
  }

  // TODO: quitar cadena de http://localhost:8000
  static send(highwayCompany) {
    const data = new FormData()
    const lo = (!highwayCompany.logo) ? '' : highwayCompany.logo
    if (typeof (highwayCompany.logo) !== 'string') {
      data.append('logo', lo)
    }

    data.append('id', highwayCompany.id)
    data.append('name', highwayCompany.name)
    data.append('codename', highwayCompany.codeName)
    data.append('short_name', highwayCompany.shortName)
    data.append('is_active', true)
    return data
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/highwayCompany.js